import React, { useState } from 'react';
import { FormGroup, Col, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';

// Migrated from redux-form to react-hook-form. The old connect()/actions were
// unused by this component, so they're dropped.
const StoreDeleteForm = ({ handleDelete, handleCancel, toggle }) => {
  const [error, setError] = useState(false);
  const { register, handleSubmit } = useForm({ defaultValues: { password: '' } });

  const onSubmit = ({ password }) => {
    // XXX hardcode
    if (password === 'everythingisawesome') {
      handleDelete();
      toggle();
      setError(false);
    } else {
      setError(true);
    }
  };

  const onCancel = () => {
    handleCancel();
    toggle();
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
        <FormGroup row>
          <Col md="12">
            {error ? <div className="alert alert-danger mt-1 mb-0 p-1"> Wrong password! </div> : null}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <label htmlFor="password">Password</label>
          </Col>
          <Col md="9">
            <input {...register('password')} type="password" className="form-control" />
          </Col>
        </FormGroup>
        <div className="float-end">
          <Button type="button" color="secondary" className="me-2" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Confirm
          </Button>
        </div>
      </form>
    </div>
  );
};

export default StoreDeleteForm;
